import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';


const EsMainBannerBlock = styled.div`
    padding-top: 0;
    overflow-x: hidden;
`;

const EsMainBannerImgBlock = styled.div`
    position: relative;
    height: 403px;
    background-position: center center;
    background-size: cover;
    background-repeat: no-repeat;
    background-image: url(${props => props.img || ''});
`;

const EsMainBannerTextBlock = styled.div`
    position: absolute;
    top: 128px;
    left: 48%;

    p {
        font-size: 28px;
        font-weight: 300;
    }
`;

const EsMainBannerBtnBlock = styled.div`
    display: inline-block;
    min-width: 110px;
    line-height: 40px;
    padding: 0 30px;
    color: #fff;
    background-color: #333;
    border-radius: 20px;
    text-align: center;
    vertical-align: 10px;
    margin-top: 100px;
`;

const EsMainBanner = () => {
    return (
        <EsMainBannerBlock>

            <EsMainBannerImgBlock img="/assets/images/sub/es-visual_bg_202008.png">
                <EsMainBannerTextBlock>

                    {/* <EsMainBannerBtnBlock>
                        <Link to='/esapply'>내 가구 견적 요청하기</Link>
                    </EsMainBannerBtnBlock> */}
                </EsMainBannerTextBlock>
            </EsMainBannerImgBlock>

        </EsMainBannerBlock>
    );
};

export default EsMainBanner;
